import { useMemo } from 'react';
import { Stack, Typography, Box } from '@mui/joy';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { getWeekDays, dateRangeToPrettyString, relativeWeekLabel, localDateToString } from '@/utils/datetime';
import { Button } from '@/ui/Button';

export function WeeklyCalendarHeader({ mealCount = 0, currentWeekStart, onDateChange, weekStartDay = 1, selectedDate }) {
  const weekDays = useMemo(() => getWeekDays(currentWeekStart), [currentWeekStart]);
  const mealsStr = mealCount === 0 ? 'Nothing planned' : mealCount > 1 ? `${mealCount} meals` : `${mealCount} meal`;

  // Desktop has no single "selected day" (the whole week shows as a table),
  // so fall back to whether the viewed week is the current one.
  const isTodaySelected = selectedDate
    ? localDateToString(selectedDate instanceof Date ? selectedDate : new Date(selectedDate)) === localDateToString(new Date())
    : relativeWeekLabel(currentWeekStart, weekStartDay) === 'Current week';

  function goToPreviousWeek() {
    const newDate = new Date(currentWeekStart);
    newDate.setDate(newDate.getDate() - 7);
    onDateChange(newDate);
  }

  function goToNextWeek() {    
    const newDate = new Date(currentWeekStart);
    newDate.setDate(newDate.getDate() + 7);    
    onDateChange(newDate);
  }

  function goToToday() {
    onDateChange(new Date());
  }

  function formatWeekRange() {
    if (!weekDays || weekDays.length === 0) return '';
    return dateRangeToPrettyString(weekDays[0], weekDays[6]);
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>      
      <Stack direction="column" gap={'3px'}>
        <Typography level="h2">{formatWeekRange()}</Typography>
        <Typography level="title-xs">{relativeWeekLabel(currentWeekStart, weekStartDay)} · {mealsStr}</Typography>
      </Stack>
      <Stack direction="row" gap={0.75} alignItems="center">
        {!isTodaySelected && <Button color="neutral" size="xssm" onClick={goToToday}>Today</Button>}
        <Button color="neutral" type="icon" size="xssm" onClick={goToPreviousWeek}>
          <ChevronLeft />
        </Button>        
        <Button color="neutral" type="icon" size="xssm" onClick={goToNextWeek}>
          <ChevronRight />
        </Button>
      </Stack>      
    </Box>
  );
}

